<p-toast key="massive-load" position="top-right">
  <ng-template pTemplate="message" let-message>
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ message.summary }}</div>
      <div class="p-toast-detail" [innerHTML]="message.detail"></div>
    </div>
  </ng-template>
</p-toast>
<router-outlet></router-outlet>
